export const getHost = () => {
  if (window.location.hostname.includes('fawful.se')) {
    return 'fawful.se'
  }

  if (window.location.hostname.includes('bowser.se')) {
    return 'bowser.se'
  }

  if (window.location.hostname.includes('arriva.guru')) {
    return 'arriva.guru'
  }

  return 'arriva.guru'
  // return 'fawful.se'
}

export const isProduction = () => getHost() === 'arriva.guru'

const buildSSOConfiguration = (
  clientId,
  namespace,
  domain,
  callbackUrl,
  scope
) => {
  if (!clientId) {
    throw new TypeError('client_id is required')
  }
  if (!namespace) {
    throw new TypeError('namespace is required')
  }
  if (!domain) {
    throw new TypeError('domain is required')
  }
  if (!callbackUrl) {
    throw new TypeError('callbackUrl is required')
  }
  if (!scope) {
    throw new TypeError('scope is required')
  }

  return {
    namespace,
    domain,
    callbackUrl,
    scope,
    client_id: clientId
  }
}

const buildCallbackUrl = (domain, path) => {
  if (window.location.hostname.includes('localhost')) {
    return `http://localhost:8080${path}`
  }
  return `https://dsp.${domain}${path}`
}

export const getSSOConfiguration = () => {
  const domain = getHost()
  const callbackUrl = buildCallbackUrl(domain, '/sso/callback')

  const conf = buildSSOConfiguration(
    'reges_dsp',
    'dsp',
    domain,
    callbackUrl,
    'user'
  )

  return conf
}
